import { userConstants } from '../_constants';
import { userService } from '../_services';
import { alertActions } from './';
import { history } from '../_helpers';
import Cookies from 'universal-cookie';

export const userActions = {
    login , logout , refreshToken
};

function login(formbody) {
    return dispatch => {
        dispatch(request(formbody));

        userService.login(formbody)
        .then( response => {
            if (response) {
                localStorage.setItem('user', JSON.stringify(response));
    
                dispatch(success(response));
                
                window.location.href = "/account/profile";
            }
        })
        .catch(error => {
            dispatch(failure(error));
            dispatch(alertActions.error(error.response));
        })
    };

    function request(formbody) { return { type: userConstants.LOGIN_REQUEST, formbody } }
    function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
    function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function logout() {
    userService.logout();
    return { type: userConstants.LOGOUT };
}

function refreshToken(user) {
    return dispatch => {
        dispatch(request(user));

        if(user){
            dispatch(success(user));
        }
        else {
            dispatch(failure('user not found'));
        }
    };

    function request(user) { return { type: userConstants.REFRESHTOKEN_REQUEST , user } }
    function success(user) { return { type: userConstants.REFRESHTOKEN_SUCCESS, user } }
    function failure(error) { return { type: userConstants.REFRESHTOKEN_FAILURE, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/user.actions.js